import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationTeamMembersForm, { ReRegistrationTeamMembersFormItem } from "../../../../forms/recadastramento/ReRegistrationTeamMembersForm";

import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";
import TmpInputSelectSearchAPICustom from "../../../../components/tempo/TmpInputSelectSearchAPICustom/TmpInputSelectSearchAPICustom";


interface ReRegistrationVocationalTraningComponentProps {
    ReRegistrationTeamMembersForm: ReRegistrationTeamMembersForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationTeamMembersFormItem) => void
    onDeleteClick: (e: ReRegistrationTeamMembersFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationTeamMembersComponent(props: ReRegistrationVocationalTraningComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Participante", align: "center", property: "Participate", type: "text" },
        { title: "Conselho", align: "center", property: "RegistrationNumber", type: "text" },
        { title: "Profissão/Ocupação", align: "center", property: "Occupation", type: "text" },
    ]

    return (

        <Grid container spacing={3}>
            <Grid item xs={7} sm={7}>
                <TmpInputSelectSearchAPICustom
                    label="Participante *"
                    name="Participate"
                    urlAPI="/sam/v1/medicalTeam/getallmedicals?textSearch="
                    maxLength={80}
                    id="Participate"
                    disabled={props.ReRegistrationTeamMembersForm.FormItemToEdit.Id > 0}
                    placeholder="Pesquise por nome ou número do conselho"
                    value={props.ReRegistrationTeamMembersForm.Participate.Value}
                    onChange={(e) => { props.onInputChange("Participate", props.ReRegistrationTeamMembersForm, e); }}
                    onBlur={(e) => { props.onInputChange("Participate", props.ReRegistrationTeamMembersForm, e); }}
                    error={props.ReRegistrationTeamMembersForm.Participate.HasError()}
                    helperText={props.ReRegistrationTeamMembersForm.Participate.Error}
                />
            </Grid>

            <Grid item xs={5} sm={5}>
                <TmpInputSelectSearchAPICustom
                    id="Occupation"
                    name="Occupation"
                    label="Profissão/Ocupação *"
                    urlAPI="/sam/v1/medicalTeam/getalloccupations?textSearch="
                    maxLength={80}
                    placeholder="Pesque pelo nome da profissão/ocupação"
                    value={props.ReRegistrationTeamMembersForm.Occupation.Value}
                    onChange={(e) => { props.onInputChange("Occupation", props.ReRegistrationTeamMembersForm, e); }}
                    onBlur={(e) => { props.onInputChange("Occupation", props.ReRegistrationTeamMembersForm, e); }}
                    error={props.ReRegistrationTeamMembersForm.Occupation.HasError()}
                    helperText={props.ReRegistrationTeamMembersForm.Occupation.Error}
                />
            </Grid>



            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.ReRegistrationTeamMembersForm.FormItemToEdit.Id > 0 ?
                        <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                            Cancelar edição do participante
                        </TmpButtonCustom>
                        : null
                    )}

                    {(props.ReRegistrationTeamMembersForm.FormItemToEdit.Id === 0 ?
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Adicionar participante na minha equipe
                        </TmpButtonCustom>
                        :
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Salvar participante na sua equipe
                        </TmpButtonCustom>
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <TmpTableBaseCustom
                    columns={headers}
                    actionEditColumn={true}
                    actionDeleteColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.ReRegistrationTeamMembersForm.FormItemList}
                />
            </Grid> 


        </Grid >

    )

}